import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=28f76516&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=28f76516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f76516",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCheckmark24px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark24px.vue').default,AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,AtomsInputField: require('/var/www/packages/theme/components/atoms/InputField.vue').default,IconsSpinner: require('/var/www/packages/theme/components/icons/spinner/Spinner.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
